module.exports = "<div id=\"mapComponent\">\n  <div class=\"row\">\n      <div class=\"col-sm-12\">\n          <div class=\"map\" appFixedAspect [aspectRatio]=\"1.5\"></div>\n      </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/widgets/map/map.component.html
// module id = ../../../../../src/widgets/map/map.component.html
// module chunks = main